<ng-container>
   <!-- took out border between practices temporarily because it does not work with sort: 
'border-top': row().product?.practiceName?.trim() === row().product?.previousPracticeName?.trim() ? '' : '1.5px solid #979797' -->
   <tr
      [class.row-clickable]="true"
      [class.row-currently-expanded]="row().isExpanded"
      [ngStyle]="{
         height: row().isEditing ? '145px' : '53.2px',
         cursor: row().subRows.length > 0 ? 'pointer' : 'default'
      }"
      [class.highlighted]="isHighlighted()"
      (click)="row().subRows.length > 0 && toggleExpand(row())">
      <td
         style="padding-right: 0px; position: relative"
         class="pricing-expanded-collapse">
         <ng-container *ngIf="row().subRows?.length > 0">
            <i class="material-icons toggle-switch">
               {{ row().isExpanded ? "remove" : "add" }}
            </i>
         </ng-container>
         <div
            *ngIf="row().status == 1 && !isRequestView() && displayAsReview()"
            class="writeback-error"
            tooltipStyleClass="pims-tooltip">
            <span class="writeback-error-inner"><i class="fa fa-close"></i></span>
         </div>
         <div
            *ngIf="row().status == 4 && !isRequestView() && displayAsReview()"
            class="writeback-skipped"
            tooltipStyleClass="pims-tooltip">
            <span class="writeback-skipped-inner"><i class="fa fa-info"></i></span>
         </div>
         <div
            *ngIf="row().status == 2 && !isRequestView() && displayAsReview()"
            class="writeback-success"
            tooltipStyleClass="pims-tooltip">
            <span class="writeback-success-inner"><i class="fa fa-check"></i></span>
         </div>
      </td>

      <td
         *ngIf="displaySites()"
         class="pricing-site">
         <div
            class="truncate-multiline"
            [pTooltip]="row().siteName"
            tooltipStyleClass="pims-tooltip">
            {{ row().siteName?.trim() }}
         </div>
      </td>

      <td
         *ngIf="displayAsReview()"
         class="pricing-prices">
         {{ row().requestedOn | date : "M/d/yyyy" }}
      </td>

      <td
         *ngIf="showPracticeColumn() && isRequestView()"
         class="pricing-recordName">
         <div
            class="truncate-multiline"
            [pTooltip]="row().practiceName"
            tooltipStyleClass="pims-tooltip">
            {{ row().practiceName?.trim() }}
         </div>
      </td>

      <td
         class="pricing-code"
         [pTooltip]="row().code"
         tooltipStyleClass="pims-tooltip">
         {{ row().code }}
      </td>

      <td
         [ngClass]="displayAsReview() ? 'pricing-recordName' : 'pricing-recordName-practice'"
         style="vertical-align: baseline !important">
         <div
            class="truncate-multiline"
            [pTooltip]="row().recordName"
            tooltipStyleClass="pims-tooltip"
            [class.pl-3]="!!row().parentId">
            <div *ngIf="row().recordType == 'SF'">
               System Fee:
               <br />
            </div>
            {{ row().recordName?.trim() }}
         </div>
      </td>

      <td
         class="pricing-pimsCategory"
         *ngIf="!displayAsReview()">
         <div
            class="truncate-multiline"
            [pTooltip]="row().pimsCategory"
            tooltipStyleClass="pims-tooltip">
            {{ row().pimsCategory }}
         </div>
      </td>

      <td class="pricing-prices">
         {{ row().l12MRevenue | currency : "USD" : "symbol" : "1.0-0" }}
      </td>

      <td
         *ngIf="!isRequestView() && !displayAsReview()"
         class="pricing-pct">
         {{ row().pctAnnualRevenue | percent : "1.2-2" }}
      </td>

      <td
         *ngIf="!isRequestView() && !displayAsReview()"
         class="pricing-pct">
         {{ row().l12MTransactionPct | percent : "1.2-2" }}
      </td>

      <td class="pricing-distinctClientCount">
         {{ row().distinctClientCount }}
      </td>

      <td class="pricing-quantityBreak">
         <i
            class="material-icons"
            *ngIf="row().quantityBreaks?.length > 1"
            style="font-size: 15px; color: #363636; vertical-align: sub">
            {{ row().isExpanded ? "remove_circle_outlined" : "add" }}
         </i>
      </td>

      <td class="pricing-prices">
         {{ row().currentPrice | currency : "USD" : "symbol" : "1.2-2" }}
      </td>
      <!--<td
         *ngIf="activeCycle()"
         class="pricing-prices">
         {{ row().modelPrice | currency : "USD" : "symbol" : "1.2-2" }}
      </td>-->

      <td
         *ngIf="!row().isEditing || isRequestView()"
         style="overflow: visible; line-height: 17px; vertical-align: baseline !important; padding-bottom: 8px"
         class="inputPriceUpdated pricing-inputPrice">
         {{ row().newPrice | currency : "USD" : "symbol" : "1.2-2" }}
         <br />
         <span
            class="pricingTextareaHidden pricing-inputPrice pr-3"
            [pTooltip]="row().rationale"
            tooltipStyleClass="pims-tooltip">
            {{ row().rationale }}
         </span>
      </td>

      <td
         *ngIf="row().isEditing && !isRequestView()"
         class="pricing-inputPrice"
         style="overflow: visible; position: relative">
         <input
            [(ngModel)]="row().newPrice"
            ngModelOptions="{standalone: true}"
            (click)="onInputClick($event)"
            [attr.data-id]="row().id"
            name="newPrice-{{ row().id }}"
            type="number"
            inputmode="decimal"
            min="0"
            (keydown)="!['-', 'e'].includes($event.key) || ($event.preventDefault() && false)"
            class="form-control mb-1"
            style="height: 35px; font-size: 12px; padding-left: 4px; padding-right: 4px; width: 55px"
            #newPriceInput />
         <div style="width: 195px !important">
            <textarea
               [(ngModel)]="row().rationale"
               ngModelOptions="{standalone: true}"
               [attr.data-id]="row().id"
               placeholder="Reason"
               minlength="6"
               (click)="onInputClick($event)"
               [ngClass]="{ invalid: !isValidRationale(false) }"
               name="rationale-{{ row().id }}"
               type="text"
               #rationaleInput
               class="form-control pricingTextarea mb-1"></textarea>
            <span class="text-xs">* Please provide a rationale for your request</span>
         </div>
      </td>

      <td
         *ngIf="!row().isEditing && displayAsReview()"
         style="overflow: visible; line-height: 17px; vertical-align: baseline !important; padding-bottom: 8px"
         class="inputPriceUpdated pricing-inputPrice">
         {{ row().opsPrice | currency : "USD" : "symbol" : "1.2-2" }}
         <br />
         <span
            class="pricingTextareaHidden pricing-inputPrice pr-3"
            [pTooltip]="row().finalComment"
            tooltipStyleClass="pims-tooltip">
            {{ row().finalComment }}
         </span>
      </td>

      <td
         *ngIf="row().isEditing && displayAsReview()"
         style="overflow: visible; position: relative"
         class="pricing-inputPrice">
         <input
            [(ngModel)]="row().opsPrice"
            ngModelOptions="{standalone: true}"
            (click)="onInputClick($event)"
            [attr.data-id]="row().id"
            name="opsPrice-{{ row().id }}"
            type="number"
            inputmode="decimal"
            min="0"
            (keydown)="!['-', 'e'].includes($event.key) || ($event.preventDefault() && false)"
            class="form-control"
            style="height: 35px; font-size: 12px; padding-left: 4px; padding-right: 4px; width: 55px" />
         <textarea
            [(ngModel)]="row().finalComment"
            ngModelOptions="{standalone: true}"
            [attr.data-id]="row().id"
            placeholder="Reason"
            minlength="6"
            (click)="onInputClick($event)"
            [ngClass]="{ invalid: !isValidRationale(true) }"
            name="finalComment-{{ row().id }}"
            type="text"
            #finalCommentInput
            class="form-control pricingTextarea"></textarea>
         <span class="text-small">* Please provide a rationale for your request</span>
      </td>

      <td
         class="pricing-prices"
         style="font-weight: 600; font-style: italic">
         {{ row().totalFees | formatCurrency }}
      </td>

      <td class="pricing-prices">
         {{ row().totalCurrentPrice | formatCurrency }}
      </td>

      <td
         [ngClass]="displayAsReview() ? '' : 'total-requested-price-title'"
         class="pricing-inputPrice">
         <ng-container *ngIf="row().totalCurrentPrice != row().totalRequestedPrice">
            {{ row().totalRequestedPrice | formatCurrency }}
         </ng-container>
      </td>

      <!--<td
         *ngIf="displayAsReview()"
         [ngStyle]="{ background: displayAsReview() ? 'unset' : '#bbe3d8' }"
         class="pricing-inputPrice">
         <ng-container>{{ row().totalPrice | formatCurrency }}</ng-container>
      </td>-->

      <td
         *ngIf="displayAsReview()"
         class="pricing-inputPrice total-requested-price-title">
         <ng-container *ngIf="row().totalCurrentPrice != row().totalOpsPrice">
            {{ row().totalOpsPrice | formatCurrency }}
         </ng-container>
      </td>

      <td
         *ngIf="displayAsReview()"
         class="pricing-prices">
         {{ row().revenueImpact | currency : "USD" : "symbol" : "1.0-0" }}
      </td>
      <td
         *ngIf="displayAsReview()"
         class="pricing-prices">
         <ng-container *ngIf="row().priceImpact">
            {{ row().priceImpact | formatCurrency }}
         </ng-container>
      </td>

      <vetcor-pricing-action-buttons
         style="width: 185px; text-align: right; padding-right: 13px; line-height: 17px; display: contents"
         [isCaptain]="displayAsReview()"
         [row]="row()"></vetcor-pricing-action-buttons>
   </tr>
   <!-- Expanded row -->
   @if (row().isExpanded) { @for (subRow of row().subRows; track subRow) {
   <vetcor-pricing-row
      [row]="subRow"
      style="width: 100%"
      [class.row-currently-expanded-under]="true"
      [displaySites]="displaySites()"
      [displayAsReview]="displayAsReview()"></vetcor-pricing-row>
   } }
</ng-container>
